/* Weaving Creation — Tallit builder: options + add-ons -> Shopify cart (line item properties) */
(function () {
  "use strict";
  var root = document.querySelector("[data-builder]");
  var form = document.querySelector("[data-product-form]");
  if (!root || !form) return;

  function money(c) {
    var fmt = (window.WC && window.WC.money) || "${{amount}}";
    var value = c / 100;
    function withCommas(n, dec) {
      var parts = n.toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case "amount": return withCommas(value, 2);
        case "amount_no_decimals": return withCommas(value, 0);
        case "amount_with_comma_separator": return withCommas(value, 2).replace(/,/g, "X").replace(/\./g, ",").replace(/X/g, ".");
        case "amount_no_decimals_with_comma_separator": return withCommas(value, 0).replace(/,/g, "X").replace(/\./g, ",").replace(/X/g, ".");
        default: return withCommas(value, 2);
      }
    });
  }
  var base = parseInt(root.getAttribute("data-base"), 10) || 0;
  var defaultVid = root.getAttribute("data-default-vid");
  var prodTitle = root.getAttribute("data-title") || "";
  function n(attr) { return parseInt(root.getAttribute(attr), 10) || 0; }
  var bagVid = root.getAttribute("data-bag-vid"), bagPrice = n("data-bag-price");
  var tefillinVid = root.getAttribute("data-tefillin-vid"), tefillinPrice = n("data-tefillin-price");
  var kippahVid = root.getAttribute("data-kippah-vid"), kippahPrice = n("data-kippah-price");
  var bukharianVid = root.getAttribute("data-bukharian-vid"), bukharianPrice = n("data-bukharian-price");
  var tekThinVid = root.getAttribute("data-tek-thin-vid"), tekThinPrice = n("data-tek-thin-price");
  var tekThickVid = root.getAttribute("data-tek-thick-vid"), tekThickPrice = n("data-tek-thick-price");
  var atarahVid = root.getAttribute("data-atarah-vid"), atarahPrice = n("data-atarah-price");
  var magenVid = root.getAttribute("data-magen-vid"), magenPrice = n("data-magen-price");
  var bagembVid = root.getAttribute("data-bagemb-vid"), bagembPrice = n("data-bagemb-price");
  // tekhelet price now depends on thread thickness (thick costs more, everywhere)
  function tekPick() {
    var thick = activeVal("tekhelet-thickness") === "Thick";
    return { vid: thick ? tekThickVid : tekThinVid, price: thick ? tekThickPrice : tekThinPrice };
  }

  var variants = [];
  try { variants = JSON.parse(form.getAttribute("data-variants") || "[]"); } catch (e) {}

  function activeVal(group) {
    var b = root.querySelector('[data-group="' + group + '"] .is-selected');
    return b ? b.getAttribute("data-val") : null;
  }
  function bindGroup(group, after) {
    var wrap = root.querySelector('[data-group="' + group + '"]');
    if (!wrap) return;
    wrap.querySelectorAll(".option__btn").forEach(function (b) {
      b.addEventListener("click", function () {
        wrap.querySelectorAll(".option__btn").forEach(function (x) { x.classList.toggle("is-selected", x === b); });
        if (after) after();
        recompute();
      });
    });
  }

  var customInput = root.querySelector("[data-atarah-custom]");
  var bagName = root.querySelector("[data-bag-name]");
  var tefillinName = root.querySelector("[data-tefillin-name]");
  var tekNote = root.querySelector("[data-tek-note]");
  var atarahSel = root.querySelector("[data-atarah]");
  var atarahNote = root.querySelector("[data-atarah-note]");
  var toggles = { bag: false, tefillin: false, kippah: false };

  var CUSTOM_ATARAH = "Custom Embroidery";
  function atarahVal() { return atarahSel ? atarahSel.value : "No Embroidery"; }
  if (atarahSel) atarahSel.addEventListener("change", function () {
    if (customInput) customInput.hidden = atarahSel.value !== CUSTOM_ATARAH;
    recompute();
  });
  var tekThickWrap = root.querySelector("[data-tek-thickness]");
  function syncTekhelet() {
    var on = activeVal("tekhelet") !== "Without Tekhelet";
    if (tekNote) tekNote.hidden = !(on && tekThinVid);
    if (tekThickWrap) tekThickWrap.hidden = !on;
  }
  bindGroup("tzitzit");
  bindGroup("knot");
  bindGroup("tekhelet", syncTekhelet);
  bindGroup("tekhelet-thickness");
  bindGroup("kippah-type");
  bindGroup("magen");
  if (customInput) customInput.addEventListener("input", recompute);
  if (bagName) bagName.addEventListener("input", recompute);
  if (tefillinName) tefillinName.addEventListener("input", recompute);

  root.querySelectorAll(".addon-toggle").forEach(function (b) {
    var key = b.getAttribute("data-toggle");
    b.addEventListener("click", function () {
      toggles[key] = !toggles[key];
      b.classList.toggle("is-on", toggles[key]);
      var wrap = root.querySelector('[data-name-wrap="' + key + '"]');
      if (wrap) wrap.hidden = !toggles[key];
      recompute();
    });
  });

  // recompute when the size variant changes (option buttons handled by theme.js)
  form.querySelectorAll('.option__btn[data-opt-name]').forEach(function (b) {
    b.addEventListener("click", function () { setTimeout(recompute, 0); });
  });

  function currentVid() {
    var el = form.querySelector("[data-variant-id]");
    return el ? el.value : defaultVid;
  }
  function currentBase() {
    var vid = currentVid();
    for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(vid)) return variants[i].price; }
    return base;
  }
  function atarahValue() {
    var v = atarahVal();
    if (v === CUSTOM_ATARAH) return (customInput && customInput.value.trim()) || "Custom (to confirm)";
    return v;
  }

  // kippah style choice (Handwoven / Bukharian); falls back to plain matching kippah
  function kippahChoice() {
    var b = root.querySelector('[data-group="kippah-type"] .is-selected');
    if (b) return { vid: b.getAttribute("data-vid"), price: parseInt(b.getAttribute("data-price"), 10) || 0, val: b.getAttribute("data-val") };
    return { vid: kippahVid, price: kippahPrice, val: null };
  }

  function recompute() {
    var total = currentBase();
    var wantsTek = activeVal("tekhelet") !== "Without Tekhelet";
    // Choosing tekhelet costs — price comes from the selected thread thickness
    // (Thin/Thick variants of the "Tekhelet Upgrade" product, both editable in admin).
    var tekSel = tekPick();
    var addTek = wantsTek && !!tekSel.vid && tekSel.price > 0;
    var wantsAtarah = atarahVal() !== "No Embroidery" && !!atarahVid;
    var wantsMagen = activeVal("magen") === "Yes" && !!magenVid;
    var bagEmb = toggles.bag && bagName && bagName.value.trim() !== "" && !!bagembVid;
    var tefEmb = toggles.tefillin && tefillinName && tefillinName.value.trim() !== "" && !!bagembVid;
    if (toggles.bag) total += bagPrice;
    if (toggles.tefillin) total += tefillinPrice;
    if (toggles.kippah) total += kippahChoice().price;
    if (addTek) total += tekSel.price;
    if (wantsAtarah) total += atarahPrice;
    if (wantsMagen) total += magenPrice;
    if (bagEmb) total += bagembPrice;
    if (tefEmb) total += bagembPrice;
    if (atarahNote) atarahNote.hidden = !wantsAtarah;
    document.querySelectorAll("[data-total]").forEach(function (e) { e.textContent = money(total); });

    var dl = root.querySelector("[data-summary]");
    if (dl) {
      var rows = [
        ["Size", sizeLabel()],
        ["Atarah Embroidery", atarahValue() + (wantsAtarah ? "  (+" + money(atarahPrice) + ")" : "")],
        ["Tzitzit Style", activeVal("tzitzit")],
        ["Tekhelet", activeVal("tekhelet")]
      ];
      if (wantsTek && activeVal("tekhelet-thickness")) rows.push(["Tekhelet Thickness", activeVal("tekhelet-thickness") + (addTek ? "  (+" + money(tekSel.price) + ")" : "")]);
      if (wantsMagen) rows.push(["Magen David Embroidery", "Yes  (+" + money(magenPrice) + ")"]);
      if (toggles.bag) rows.push(["Matching Tallit Bag", (bagName && bagName.value.trim()) ? 'Yes — "' + bagName.value.trim() + '"  (+' + money(bagembPrice) + ')' : "Yes"]);
      if (toggles.tefillin) rows.push(["Matching Tefillin Bag", (tefillinName && tefillinName.value.trim()) ? 'Yes — "' + tefillinName.value.trim() + '"  (+' + money(bagembPrice) + ')' : "Yes"]);
      if (toggles.kippah) rows.push(["Matching Kippah", kippahChoice().val || "Yes"]);
      dl.innerHTML = rows.map(function (r) {
        return '<div class="summary__row"><dt>' + r[0] + "</dt><dd>" + (r[1] || "—") + "</dd></div>";
      }).join("");
    }
  }
  function sizeLabel() {
    var b = form.querySelector('.option__btn[data-opt-name].is-selected');
    if (b) return b.getAttribute("data-opt-value");
    var vid = currentVid();
    for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(vid)) return variants[i].title; }
    return "—";
  }

  // size guide modal handled in wc-pdp.js (works for all product types)

  // add to cart
  function add(btn) {
    var vid = currentVid();
    if (!vid) return;
    var tzitzit = activeVal("tzitzit");
    var tekhelet = activeVal("tekhelet");
    var mainProps = {
      "Atarah Embroidery": atarahValue(),
      "Tzitzit Style": tzitzit,
      "Tekhelet": tekhelet
    };
    if (tekhelet !== "Without Tekhelet" && activeVal("tekhelet-thickness")) mainProps["Tekhelet Thickness"] = activeVal("tekhelet-thickness");
    var items = [{ id: parseInt(vid, 10), quantity: 1, properties: mainProps }];
    if (atarahVal() !== "No Embroidery" && atarahVid) {
      items.push({ id: parseInt(atarahVid, 10), quantity: 1, properties: { "Text": atarahValue(), "For": prodTitle } });
    }
    if (tekhelet !== "Without Tekhelet") {
      var tp = tekPick();
      if (tp.vid && tp.price > 0) {
        items.push({ id: parseInt(tp.vid, 10), quantity: 1, properties: { "Style": tekhelet, "Thickness": activeVal("tekhelet-thickness") || "Thin", "For": prodTitle } });
      }
    }
    if (activeVal("magen") === "Yes" && magenVid) {
      items.push({ id: parseInt(magenVid, 10), quantity: 1, properties: { "For": prodTitle } });
    }
    if (toggles.bag && bagVid) {
      var p = {}; if (bagName && bagName.value.trim()) p["Name Embroidery"] = bagName.value.trim();
      items.push({ id: parseInt(bagVid, 10), quantity: 1, properties: p });
      if (bagName && bagName.value.trim() && bagembVid) items.push({ id: parseInt(bagembVid, 10), quantity: 1, properties: { "Name": bagName.value.trim(), "On": "Tallit bag", "For": prodTitle } });
    }
    if (toggles.tefillin && tefillinVid) {
      var pt = { "For": prodTitle }; if (tefillinName && tefillinName.value.trim()) pt["Name Embroidery"] = tefillinName.value.trim();
      items.push({ id: parseInt(tefillinVid, 10), quantity: 1, properties: pt });
      if (tefillinName && tefillinName.value.trim() && bagembVid) items.push({ id: parseInt(bagembVid, 10), quantity: 1, properties: { "Name": tefillinName.value.trim(), "On": "Tefillin bag", "For": prodTitle } });
    }
    if (toggles.kippah) {
      var kc = kippahChoice();
      if (kc.vid) items.push({ id: parseInt(kc.vid, 10), quantity: 1, properties: kc.val ? { "Style": kc.val, "For": prodTitle } : {} });
    }

    var labels = document.querySelectorAll("[data-builder-add]");
    labels.forEach(function (b) { b.disabled = true; });
    window.WCBuilderAdd(items).catch(function (err) { alert(err.message || "Unable to add"); })
      .finally(function () { labels.forEach(function (b) { b.disabled = false; }); });
  }
  document.querySelectorAll("[data-builder-add]").forEach(function (b) {
    b.addEventListener("click", function () { add(b); });
  });

  syncTekhelet();
  recompute();
})();
